import { createAction, props } from '@ngrx/store';

import { Customer, CustomerLocation } from '../../shared/models/shared.model';

export const searchCustomers = createAction(
  '[Customer] Search Customers',
  props<{ searchtext: string }>(),
);
export const clearCustomers = createAction('[Customer] Clear Customers');
export const getCustomersRequest = createAction(
  '[Customer] Get Customers',
  props<{ searchtext: string }>(),
);
export const getCustomersError = createAction(
  '[Customer] Get Customers Error',
  props<{ error: Error }>(),
);
export const getCustomersSuccess = createAction(
  '[Customer] Get Customers Success',
  props<{ customers: Customer[] }>(),
);
export const setSelectedCustomerId = createAction(
  '[Customer] Set selected customer id',
  props<{ customerId?: number }>(),
);
export const setSelectedCustomer = createAction(
  '[Customer] Set selected customer',
  props<{ customer: Customer }>(),
);

export const loadCustomersRequest = createAction('[Customer] Load Customers request');
export const upsertCustomerRequest = createAction(
  '[Customer] Upsert Customer request',
  props<{ customer: Customer }>(),
);
export const upsertCustomerSuccess = createAction(
  '[Customer] Upsert Customer success',
  props<{ customer: Customer }>(),
);
export const upsertCustomerError = createAction(
  '[Customer] Upsert Customer Error',
  props<{ error: Error }>(),
);

export const getLocationsRequest = createAction(
  '[Customer] Get Locations',
  props<{ customerId?: number }>(),
);
export const getLocationsError = createAction(
  '[Customer] Get Locations Error',
  props<{ error: Error }>(),
);
export const getLocationsSuccess = createAction(
  '[Customer] Get Locations Success',
  props<{ locations: CustomerLocation[] }>(),
);
export const setSelectedLocation = createAction(
  '[Customer] Set selected location',
  props<{ locationId?: number }>(),
);

export const deleteLocationWithConfirmation = createAction(
  '[Customer] Delete Location with Confirmation',
  props<{ id: number }>(),
);
export const deleteLocationRequest = createAction(
  '[Customer] Delete Location Request',
  props<{ id: number }>(),
);
export const deleteLocationSuccess = createAction(
  '[Customer] Delete Location Success',
  props<{ id: number }>(),
);
export const deleteLocationError = createAction(
  '[Customer] Delete Location Error',
  props<{ error: Error }>(),
);

export const upsertLocationRequest = createAction(
  '[Customer] Upsert Location request',
  props<{ customerId: number; location: CustomerLocation }>(),
);
export const upsertLocationSuccess = createAction(
  '[Customer] Upsert Location success',
  props<{ location: CustomerLocation }>(),
);
export const upsertLocationError = createAction(
  '[Customer] Upsert Location Error',
  props<{ error: Error }>(),
);
export const clearSelectedCustomer = createAction('[Contactperson] Clear selected customer');
